import Vue from 'vue';
import VueRouter from 'vue-router';
import authRoutes from './authRoutes';
import curryCrudRoutesFor from './crudRoutesFor';
import VueRouterMiddleware, { middleware } from 'vue-router-middleware';
import i18n from '@/i18n';
import { kebabCase } from 'lodash';

Vue.use(VueRouter);

const crudRoutesFor = curryCrudRoutesFor(i18n);

const routes = [
    // Make sure we always end up at the login.
    { path: '/', redirect: '/login' },
    {
        path: `/${kebabCase(i18n.t('pageNotFound')).toLowerCase()}`,
        name: '404',
        component: () => import(/* webpackChunkName: "[request]" */ '@/views/errors/404.vue'),
    },
    { path: '*', redirect: `/${kebabCase(i18n.t('pageNotFound').toLowerCase())}` },
    // To access these routes you will need to be authenticated
    ...middleware('auth', [
        ...crudRoutesFor('measures'),
        ...crudRoutesFor('customers'),
    ]),

    // For these routes you will not need to be authenticated
    // when authenticated you will be redirect to this ↓
    ...middleware({ 'redirect-when-auth': { name: 'measures' } }, [
        ...authRoutes(i18n),
    ]),
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

const requireContext = require.context('./middlewares', false, /.*\.js$/);

const middlewares = requireContext
    .keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .reduce((middlewares, [name, middleware]) => {
        return { ...middlewares, [name]: middleware.default };
    }, {});

Vue.use(VueRouterMiddleware, {
    router,
    middlewares,
});

export default router;
